import axios from 'axios'
import NProgress from 'nprogress'
const instance = axios.create({
  headers: {

  }
})

instance.interceptors.request.use(config => {
  if (config.url.includes('/getServiceVersion') || config.url.includes('/userAuth') || config.url.includes('user/tokenBalance')) {
    config.withCredentials = true
  }
  NProgress.start()
  return config
})

instance.interceptors.response.use(response => {
  NProgress.done()
  return response
}, error => {
  NProgress.done()
  return Promise.reject(error)
})

export default instance
